import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import SearchIcon from "@mui/icons-material/Search";

export default function Sidedrawer({
  open,
  setOpen,
  category,
  selectedServices = [],
  onServiceToggle,
}) {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);

  if (!category) {
    return null;
  }

  const hasSelectedService =
    Array.isArray(selectedServices) && selectedServices.length > 0;

  const handleGoToCart = (e) => {
    if (e) e.preventDefault();
    if (!hasSelectedService) {
      setError("Please select at least one service before proceeding to cart.");
    } else {
      setError("");
      setOpen(false);
      navigate("/service-cart");
    }
  };

  return (
    <>
      <div className={`base ${open ? "active" : ""}`}>
        <div className="sidebar_filter_main">
          <div className="sidebar_filter_header">
            <div className="drawer-heading">
              <h1>{category.servicesname}</h1>
              <p className="btn_sev_box_uper">{category.totalservices}</p>
            </div>
            <div className="close-search">
              <div className="search-main-outer">
                <div className="search_icon_animation">
                  <div className="search-box sidedrawer-search-box">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />

                    <button onClick={() => setSearchOpen(!searchOpen)}>
                      <SearchIcon />
                    </button>
                  </div>
                </div>
                <div className="search_sec_long">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <input
                      type="text"
                      placeholder="Search Service...."
                      className="search_input_long"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button type="button" className="search_btn_long">
                      SEARCH
                    </button>
                  </form>
                </div>
              </div>

              <button
                className="close_btn"
                onClick={() => {
                  setError("");
                  setOpen(false);
                }}
              >
                ✕
              </button>
            </div>
          </div>
          <div className="sidebar_content">
            <div className="row g-3">
              {Array.isArray(category.services) &&
                category.services.map((service) => {
                  const inputId = `sidedrawer-service-${category.id}-${service.id}`;
                  const isChecked = !!selectedServices.find(
                    (item) => item.id === service.id,
                  );
                  return (
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 col-12"
                      key={service.id}
                    >
                      <div className="services_list_caregiver">
                        <ul className="service_list">
                          <li>
                            <input
                              type="checkbox"
                              id={inputId}
                              checked={isChecked}
                              onChange={() => {
                                setError("");
                                onServiceToggle(service);
                              }}
                            />
                            <label className="outer_label" htmlFor={inputId}>
                              <div className="service_content">
                                <label
                                  className="service_title"
                                  htmlFor={inputId}
                                >
                                  {service.name}
                                </label>
                                <p className="service-desc">
                                  {service.subtitle}
                                </p>
                              </div>

                              <div className="service_price">
                                <span className="discount">
                                  {service.offer}
                                </span>

                                <div className="price_box">
                                  <span className="current_price">
                                    {service.price}
                                  </span>
                                  <span className="old_price">
                                    {service.oldPrice}
                                  </span>
                                </div>
                                <div className="service_time">
                                  <small>Duration : </small>
                                  <span>{service.duration}</span>
                                </div>
                              </div>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                })}

              {error && (
                <div
                  className="alert alert-danger py-2 px-3 mt-3 mb-0 text-center small fw-bold"
                  style={{ borderRadius: "8px", fontSize: "13px" }}
                >
                  ⚠️ {error}
                </div>
              )}

              <div className="cart_btns">
                <button
                  type="button"
                  onClick={handleGoToCart}
                  style={{
                    opacity: hasSelectedService ? 1 : 1,
                    cursor: hasSelectedService ? "pointer" : "not-allowed",
                    width: "100%",
                    transition: "all 0.2s ease",
                  }}
                >
                  <ShoppingCartOutlinedIcon /> Go to Cart{" "}
                  {hasSelectedService ? `(${selectedServices.length})` : ""}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
